import { useEffect, useMemo, useState } from "react";
import { useLanguage } from "../../../../stores/LanguageStore";
import { IconCheck, IconLoader } from "@tabler/icons-react";
import {
  Loader,
  Stack,
  Text,
  Timeline,
  TimelineItem,
} from "@mantine/core";

const StepLoad = ({ ...props }) => {
  const lang = useLanguage((s) => s.language);
  const [loadingStep, setLoadingStep] = useState(0);

  const steps = useMemo(
    () => [
      lang.resellers.onboarding.loading.step1,
      lang.resellers.onboarding.loading.step2,
      lang.resellers.onboarding.loading.step3,
    ],
    [lang]
  );

  useEffect(() => {
    setTimeout(() => {
      setLoadingStep(1);
      setTimeout(() => {
        setLoadingStep(2);
      }, 1000);
    }, 2500);
  }, []);

  return (
      <Stack>
        <Text fz={24} mb={8}>
          {lang.home.create_campaign.step3.title2}
        </Text>

        <Timeline active={loadingStep} color="tertiary.8" bulletSize={28}>
          {steps.map((step, index) => (
            <TimelineItem
              key={step}
              title={
                <Text opacity={loadingStep >= index ? 1 : 0.5} size="xl">
                  {step}
                </Text>
              }
              bullet={
                loadingStep === index ? (
                  <Loader type="oval" size={18} color="#fcfbff" />
                ) : loadingStep > index ? (
                  <IconCheck size={24} />
                ) : (
                  <IconLoader size={24} />
                )
              }
              className={`animate__animated ${"animate__fadeInUp"}`}
              style={{
                animationDelay: `${0.2 * index}s`,
              }}
            />
          ))}
        </Timeline>
      </Stack>
  );
};

export default StepLoad;
